import { useEffect, useReducer } from "react";
import { controlOptions, reducer } from "../util/reducer";
import { usePrevious } from '@osu/react-ui'
import { useUpdateHomePageQuickLinkPreferencesMutation } from "../../../../services/graphql/api.js";
import { useQuickLinksWithPreferences as useQuickLinks } from "../../../../Search/hooks/useQuickLinks.js";
import { compareTwoLinkArrays } from "../util/functions.js";
import { validations } from "../util/constants.js";

function useLinks() {
  const { custom, links = [], isLoading: isQuickLinksLoading, isSuccess: isQuickLinksSuccess } = useQuickLinks();
  const [preferencesState, updateLinks] = useReducer(reducer, {
    list: links,
  });
  const previousLinks = usePrevious(links)
  const dataLoaded = !previousLinks?.length && links?.length
  const newDataAdded = previousLinks?.length && compareTwoLinkArrays(links, previousLinks)
  const datasourceChangedDetected = dataLoaded || newDataAdded
  const [updateApiCb, { isLoading: isSubmissionLoading, isSuccess, isError }] = useUpdateHomePageQuickLinkPreferencesMutation()
  const isLoading = isQuickLinksLoading || isSubmissionLoading

  const onSubmit = () => {
    updateApiCb({
      links: preferencesState?.list ?? []
    })
  }
  const onReset = () => {
    updateLinks({
      type: controlOptions.reset,
      links,
    });
    updateApiCb({
      links: []
    })
  }

  useEffect(() => {
    if(datasourceChangedDetected) {
      updateLinks({
        type: controlOptions.datasourcechange,
        links,
      });
    }
  }, [datasourceChangedDetected, links])

  const hasNoPreference = !custom

  let errorMessage = '', infoMessage = '', successMessage = ''
  if(preferencesState?.list?.length > validations.quickLinks.max) {
    errorMessage = `You can only add up to ${validations.quickLinks.max} links, please remove links to save your preferences.`
  } else if (preferencesState?.list?.length === validations.quickLinks.max) {
    infoMessage = `You have reached the maximum number of ${validations.quickLinks.max} links, please remove a link to add another one.`
  }
  const overMax = preferencesState?.list?.length > validations.quickLinks.max;
  const saveDisabled = isLoading || overMax;

  if(isQuickLinksLoading) {
    infoMessage = `Please wait, quick links are loading...`
  }  else if(isSubmissionLoading) {
    infoMessage = `Please wait, your preferences are being saved...`
  } 
  
  if (isSuccess) {
    infoMessage = ''
    successMessage = `Your preferences have been successfully saved.`
  }

  if(isError) {
    errorMessage = 'There was an issue saving your preferences. Please try to save again.'
  }

  return {
      _links: links,
    preferencesState,
    updateLinks,
    onReset,
    onSubmit,
    saveDisabled,
    hasNoPreference,
    errorMessage,
    infoMessage,
    successMessage,
    isLoading,
    isSuccess: isQuickLinksSuccess || isSuccess
  }
}

export default useLinks;
